module.exports = __webpack_public_path__ + "static/jonathan-agoot-machine-learning-prototype-roadmap-36ba514ebcf28fff4aab8044cdc3e5f9.jpg";